import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'When a customer switches into any asset mode',
  name: 'asset_mode_switched',
  params: [
    {
      description: 'The asset mode the user switched to',
      name: 'asset_mode',
      required: true,
      type: 'enum',
      values: ['edit', 'view', 'presentation', 'comment'],
    },
    {
      description:
        'Which quick tool opened this mode, when the click came from the asset details toolbar or the Versions panel Add version menu',
      name: 'quick_tool',
      required: false,
      type: 'string',
    },
    {
      description:
        'The asset details surface whose quick tool opened this mode: the toolbar or the Versions panel Add version menu. Omitted when the user switched modes with the mode switcher.',
      name: 'source',
      required: false,
      type: 'enum',
      values: ['asset_modal_quick_tools', 'asset_modal_versions_menu'],
    },
    {
      description: 'The category of the asset',
      name: 'category',
      required: true,
      type: 'enum',
      values: ['asset_details'],
    },
  ],
};

export default META;
